import {
  topicFormCancelBtnCssPath,
  topicFormCssPath,
  topicFormEmailChannelCssPath,
  topicFormIdCssPath,
  topicFormInputKeyCssPath,
  topicFormSaveBtnCssPath,
  topicFormSMSChannelCssPath,
  topicFormTitleCssPath,
} from './cssPaths.js';

export function fill({ mode, title, saveBtnText }, topic, channels) {
  $(topicFormCssPath).attr('data-mode', mode);
  $(topicFormTitleCssPath).text(title);
  $(topicFormSaveBtnCssPath).text(saveBtnText);

  $(topicFormIdCssPath).val(topic.id || '');
  $(topicFormInputKeyCssPath).val(topic.key || '');

  const { emailChannels, smsChannels } = prepareChannelsDataOptions();

  $(topicFormEmailChannelCssPath).html(emailChannels.map(optionHTML(topic.emailChannel)));
  $(topicFormSMSChannelCssPath).html(smsChannels.map(optionHTML(topic.smsChannel)));

  function prepareChannelsDataOptions() {
    return channels.reduce(
      (acc, channel) => {
        if (channel.type === 'email') {
          acc.emailChannels.push(createOptionData(channel));
        } else if (channel.type === 'sms') {
          acc.smsChannels.push(createOptionData(channel));
        }
        return acc;
      },
      {
        emailChannels: [createOptionData({ id: '', name: '— None Selected —' })],
        smsChannels: [createOptionData({ id: '', name: '— None Selected —' })],
      }
    );
  }

  function createOptionData(channel = { id: '', name: '' }) {
    return { value: JSON.stringify(channel.id ? channel : {}), id: channel.id, content: channel.name };
  }

  function optionHTML(selectedChannel) {
    return (channelOption) =>
      `<option value='${channelOption.value}' data-info="${channelOption.info}" ${selectedValue(
        channelOption,
        selectedChannel
      )}>${channelOption.content}</option>`;
  }

  function selectedValue(channelOption, selectedChannel) {
    return channelOption.id === selectedChannel.id ? 'selected' : '';
  }
}

export function onChangeKey(cb) {
  $(document).on('input', topicFormInputKeyCssPath, function () {
    this.value = cb(this.value);
  });
  $(document).on('paste', topicFormInputKeyCssPath, (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData('Text');
    pastedData = cb(pastedData);
    e.target.value += pastedData; // eslint-disable-line no-param-reassign
    e.preventDefault();
  });
}

export function getData() {
  const id = $(topicFormIdCssPath).val();
  const key = $(topicFormInputKeyCssPath).val();
  const emailChannel = JSON.parse($(topicFormEmailChannelCssPath).val());
  const smsChannel = JSON.parse($(topicFormSMSChannelCssPath).val());
  return { id, key, emailChannel, smsChannel };
}

export function onSubmit(cb) {
  $(document).on('click', topicFormSaveBtnCssPath, function () {
    cb({ mode: $(this).closest(topicFormCssPath).attr('data-mode'), data: getData() });
  });
}

export function onCancel(cb) {
  $(document).on('click', topicFormCancelBtnCssPath, function () {
    cb({ mode: $(this).closest(topicFormCssPath).attr('data-mode'), data: getData() });
  });
}
